import io from "socket.io-client";

export const createSocketClient = (socketUrl, options = {}) => {
  if (!socketUrl || typeof socketUrl !== "string") {
    throw new Error("socketUrl is required to establish a socket connection");
  }

  return io(socketUrl, {
    transports: ["websocket", "polling"],
    autoConnect: true,
    // Each PDF/ZIP export must get its own independent socket connection.
    // Without forceNew, socket.io-client multiplexes all calls to the same URL
    // into a single shared connection. When one export finishes and disconnects,
    // it kills the socket for ALL other in-flight exports.
    forceNew: true,
    // Disable automatic reconnection — each export manages its own fallback
    // (polling) when the socket fails. Reconnection would create duplicate
    // listeners and unpredictable event delivery.
    reconnection: false,
    ...options,
  });
};

export const disconnectSocket = (socket) => {
  if (!socket) return;

  try {
    if (socket.connected || socket.disconnected === false) {
      socket.disconnect();
    }
  } catch (err) {
    // swallow disconnect errors as they are non-fatal
    console.warn("Failed to disconnect socket", err);
  }
};
